import { msg } from '@lingui/core/macro'
import type { MessageDescriptor } from '@lingui/core'
import { FEATURE_FLAGS } from './feature-flags'

/**
 * The landing's questions, as descriptors rather than resolved strings, because TWO places render them: the
 * accordion, off the `useLingui` instance, and the route's `head()`, off the request-scoped one. One array is what
 * keeps the `FAQPage` markup from answering a question the page does not show — the drift that gets a rich result
 * pulled. Written for companies; the professionals' questions are answered in their own section.
 */
export const LANDING_FAQ: {
  question: MessageDescriptor
  answer: MessageDescriptor
  /** Renders the API reference link after the prose. The markup carries the prose alone — a strict subset of the page. */
  docsLink?: boolean
}[] = [
  {
    question: msg`What is a Psychographic Profile?`,
    answer: msg`It is a structured description of how a person thinks, decides and works: competences, values and personality. It is built from our test and expressed as indicators you can compare with a position, a team or the market.`,
  },
  {
    question: msg`How do we get our people to take the test?`,
    answer: msg`All you need is their email to send them the invitation. The test takes about 22 minutes, works on any device, and can be paused and resumed at any time.`,
  },
  {
    question: msg`What will we see of each professional?`,
    answer: msg`Their Psychographic Profile and how it fits the positions, teams and offers you select.`,
  },
  {
    question: msg`Is it scientifically validated?`,
    answer: msg`The model rests on established psychometric research and is continuously recalibrated with our own sample of analyzed profiles.`,
  },
  {
    question: msg`How do you handle our data?`,
    answer: msg`We apply the various international privacy and protection regulations: data is kept secure, information is never sold to third parties, and accounts and results can be deleted at any time.`,
  },
  {
    question: msg`How does the API work?`,
    answer: msg`It is a REST API for your server plus an SDK that runs in the browser to carry the test flow. You create positions and professionals, invite them, and read fit levels and reports as JSON.`,
    docsLink: true,
  },
  // Gated with the section it describes: with pricing off, the page shows no prices, so the markup must claim none.
  ...(FEATURE_FLAGS.showPricing
    ? [
        {
          question: msg`What are the limits of each plan?`,
          answer: msg`The Companies plan is billed by employee band, from 75 €/month for up to 25 employees, and includes every feature. The Professionals plan is free with no time limit.`,
        },
      ]
    : []),
]
